<template>
  <v-card class="payment-method-card" elevation="0">
      <div class="payment-header">
        <div>
          <div class="payment-title">Payment methods</div>
          <div class="payment-subtitle">{{ paymentSubtitle }}</div>
        </div>
      </div>

      <div class="payment-actions" v-if="customer">
            <CardOnFile :id="customer.id" :type="type" @submit="reload()" :selectedMerchant="selectedMerchant" />
            <CreditCard v-if="type === 'customer'" :Cards="cards" @getCard="getCard" :customer="customer" @submit="reload"
              :stripeId="customer.stripeId"></CreditCard>
            <CreditCard v-else :Cards="cards" @getCard="getCard" :donor="customer" @submit="reload"
              :stripeId="customer.stripeId"></CreditCard>
      </div>

      <div class="merchant-selector">
        <v-select dense outlined hide-details :items="MerchantAccount" v-model="selectedMerchant" return-object item-text="name"
          label="Payment category">
          <template v-slot:selection="{ item }"><span class="merchant-option__name">{{ item.name }}</span><PaymentProviderChip :provider="providerForCategory(item)" /></template>
          <template v-slot:item="{ item }"><span class="merchant-option__name">{{ item.name }}</span><PaymentProviderChip :provider="providerForCategory(item)" /></template>
        </v-select>
      </div>

      <v-progress-linear v-if="isLoading" indeterminate color="primary" />

      <div v-if="!isLoading && cards && cards.length" class="saved-methods">
        <div v-for="(card, index) in cards" :key="card.id || index" class="saved-method">
          <div class="method-icon"><v-icon color="primary">{{ card.payment_method_type === 'ach' ? 'mdi-bank-outline' : 'mdi-credit-card-outline' }}</v-icon></div>
          <div class="method-info">
            <span class="method-brand"><span v-if="card.card_type">{{ card.card_type }}</span><span v-else-if="card.account_type">{{ card.account_type }}</span><span v-else>Payment method</span></span>
            <strong>Ending in {{ card.last4 }}</strong>
            <span v-if="card.expiry_month">Expires {{ card.expiry_month }}/{{ card.expiry_year }}</span>
            <span>Added {{ card.created_at | moment("L") }}</span>
            <div class="method-tags">
              <v-chip x-small color="primary" outlined class="method-type text-capitalize">{{ card.payment_method_type === 'ach' ? 'Bank account' : 'Card' }}</v-chip>
              <PaymentProviderChip :provider="providerForCard(card)" />
            </div>
          </div>
          <div class="method-menu">
                  <v-menu bottom right offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon aria-label="Payment method actions">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="deleteCard(card)">
                        <v-list-item-icon><v-icon size="18">mdi-delete-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Remove payment method</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
          </div>
        </div>
      </div>
      <div v-else-if="!isLoading" class="payment-empty">
        <v-icon color="#9BA69C" size="32">mdi-credit-card-off-outline</v-icon>
        <strong>No payment methods added</strong>
        <span>Add a card or bank account for future fee payments.</span>
      </div>
  </v-card>
</template>

<script>
import donationCategoryService from "@/modules/DonationCategory/service.js";
import payCompassService from "@/modules/PayCompass/service.js";
import stripeService from "@/modules/Stripe/service.js";
import { mapGetters } from "vuex";
const CreditCard = () => import("@/modules/Customer/components/CreditCard.vue");
const CardOnFile = () => import("@/modules/SecretManager/components/CardsOnFile.vue");

export default {
  name: "Paymentmethod-list",
  props: ['type', 'customer'],
  data() {
    return {
      selectedMerchant: null,
      MerchantAccount: [],
      cards: [],
      isLoading: false,
    };
  },
  computed: {
    // ...mapGetters("customer", ["customer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
    paymentSubtitle() {
      return this.type === "customer"
        ? "Cards and bank accounts available for school fee payments"
        : "Cards and bank accounts available for donation payments"
    },
  },
  components: {
    CreditCard,
    CardOnFile,
  },
  async created() {
    await this.getDonationCategoryList();
  },
  watch: {
    selectedMerchant(val) {
      // console.log('val', val)
      // console.log('customer', customer)
      if (val) {
        // this.cards = []
        this.getCard()
      }

    },
  },
  methods: {
    providerForCategory(category) {
      return category && category.MerchantAccount && category.MerchantAccount.provider
        ? category.MerchantAccount.provider
        : "PAYCOMPASS"
    },
    providerForCard(card) {
      return card && card.provider ? card.provider : this.providerForCategory(this.selectedMerchant)
    },
    async reload() {
      this.isLoading = true
      if (this.selectedMerchant) {
        this.getCard()
      }

    },
    deleteCard(card) {
    this.$swal({
        title: "Remove payment method?",
        text: `The payment method ending in ${card.last4} will no longer be available.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Remove",
      }).then((result) => {
        if (result.value) {

          const mapping = this.mappingForSelectedCategory()
          const request = this.providerForCategory(this.selectedMerchant) === "STRIPE"
            ? stripeService.deleteMerchantPaymentMethod(mapping.id, card.id, this.selectedMerchant.id)
            : payCompassService.deleteCard({ id: card.id, donationCategoryId: this.selectedMerchant.id })
          request.then(result => {
            console.log('result', result)
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Payment method removed",
              });
            this.reload()
          })
        }
      });

    },
    getCard() {
      this.cards = []
      this.isLoading = true
      //console.log('get card customer', this.customer, this.selectedMerchant)
      const mapping = this.mappingForSelectedCategory()
      if (mapping) {
        const request = this.providerForCategory(this.selectedMerchant) === "STRIPE"
          ? stripeService.getMerchantPaymentMethods(mapping.id, this.selectedMerchant.id)
          : payCompassService.getAllCard(mapping.payCompassId, { donationCategoryId: this.selectedMerchant.id })
        request.then(response => {
          if (response.data.length) {
            this.cards = response.data
          }

          this.isLoading = false
        }).catch(error => {
          console.log('error', error)
          this.isLoading = false
        })
      } else {
        this.isLoading = false
      }
    },
    mappingForSelectedCategory() {
      if (!this.selectedMerchant || !this.customer || !this.customer.MerchantCustomers) return null
      let mapping = null
      this.customer.MerchantCustomers.map(row => {
        const selectedMerchantAccountId = this.selectedMerchant.MerchantAccount && this.selectedMerchant.MerchantAccount.id
        if (row.DonationCategoryId === this.selectedMerchant.id && (!selectedMerchantAccountId || row.MerchantAccountId === selectedMerchantAccountId)) {
          mapping = row
        }
      })
      return mapping
    },
    getDonationCategoryList() {
      return donationCategoryService.getAll().then((response) => {
        //console.log('response merchant', response)
        this.MerchantAccount = response.data;
        if (this.type === 'customer') {
          this.MerchantAccount.map(row => {
            if (row.id === this.currentBusiness.DefaultSchoolFeeId) {
              this.selectedMerchant = row
            }
          })
        } else {
          this.MerchantAccount.map(row => {
            if (row.id === this.currentBusiness.DefaultDonationId) {
              this.selectedMerchant = row
            }
          })
        }
        this.getCard()
      });
    },
  }
}
</script>

<style scoped>
.payment-method-card { border: 1px solid #e3e9e3; border-radius: 11px !important; overflow: hidden; }
.payment-header { padding: 17px 17px 8px; }
.payment-title { color: #28362c; font-size: 14px; font-weight: 750; }
.payment-subtitle { max-width: 420px; margin-top: 3px; color: #879388; font-size: 10px; line-height: 1.45; }
.payment-actions { display: flex; padding: 9px 17px 15px; border-bottom: 1px solid #edf0ed; flex-wrap: wrap; gap: 7px; }
.merchant-selector { max-width: 100%; padding: 14px 17px; }
.merchant-selector ::v-deep .v-input__slot { border-radius: 8px !important; }
.merchant-option__name { min-width: 0; margin-right: 10px; overflow: hidden; flex: 1; text-overflow: ellipsis; white-space: nowrap; }
.saved-methods { border-top: 1px solid #edf0ed; }
.saved-method { display: grid; grid-template-columns: 42px minmax(0, 1fr) 38px; align-items: center; gap: 12px; min-height: 112px; padding: 14px 16px; border-bottom: 1px solid #edf0ed; }
.saved-method:last-child { border-bottom: 0; }
.method-icon { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; background: #eaf6eb; }
.method-info { display: flex; min-width: 0; flex-direction: column; }
.method-info strong { margin: 2px 0; color: #35433a; font-size: 13px; }
.method-info > span { color: #89948a; font-size: 10px; }
.method-info .method-brand { margin: 0; color: #667469; font-size: 10px; font-weight: 750; letter-spacing: .04em; text-transform: uppercase; }
.method-tags { display: flex; margin-top: 8px; flex-wrap: wrap; gap: 5px; align-items: center; }
.method-menu { align-self: center; }
.payment-empty { display: flex; min-height: 145px; align-items: center; justify-content: center; flex-direction: column; gap: 5px; color: #647067; text-align: center; }
.payment-empty strong { font-size: 12px; }
.payment-empty span { color: #929d94; font-size: 10px; }
@media (max-width: 599px) {
  .payment-subtitle { max-width: none; }
  .payment-actions { align-items: stretch; flex-direction: column; }
  .payment-actions ::v-deep .payment-action-button { width: 100%; }
  .saved-method { grid-template-columns: 40px minmax(0, 1fr) 34px; }
}
</style>
